import { Link } from 'react-router-dom';
import { ChevronRight, FileText } from 'lucide-react';
import type { Section } from '@/types';

interface SectionRowProps {
  section: Section;
}

export function SectionRow({ section }: SectionRowProps) {
  const href = section.category?.slug
    ? `/${section.category.slug}/${section.slug}`
    : `/sections/${section.slug}`;

  return (
    <Link
      to={href}
      className="group flex items-center gap-4 p-4 rounded-lg border bg-card hover:border-primary/50 hover:shadow-sm transition-all"
    >
      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-muted flex items-center justify-center">
        <FileText className="h-5 w-5 text-muted-foreground" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-medium text-foreground group-hover:text-primary transition-colors">
          {section.name}
        </h3>
        {section.description && (
          <p className="mt-0.5 text-sm text-muted-foreground line-clamp-1">
            {section.description}
          </p>
        )}
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        {typeof section.article_count === 'number' && (
          <span className="text-xs text-muted-foreground">
            {section.article_count} {section.article_count === 1 ? 'article' : 'articles'}
          </span>
        )}
        <ChevronRight className="h-5 w-5 text-muted-foreground group-hover:text-primary transition-colors" />
      </div>
    </Link>
  );
}
